import axios from "axios";
import { T, APIS } from "../../Constants";

type SavePlanFiles = T.API.ToAxios<T.API.EDL.PLAN.SavePlanFiles>;

type GetJsonFromPdf = T.API.ToAxios<T.API.EDL.PLAN.GetJsonFromPdf>;

type GetEquipmentsAnnotations = T.API.ToAxios<T.API.EDL.PLAN.GetEquipmentsAnnotations>;

type GetExistingLinks = T.API.ToAxios<T.API.EDL.PLAN.GetExistingLinks>;

/** Save plan files in a submission directory and treat them */
export const savePlanFiles: SavePlanFiles = params => axios.post(APIS.PLAN_API + "save", params);

/** Get the json data from a pdf file */
export const getJsonFromPdf: GetJsonFromPdf = params => axios.post(APIS.PLAN_API + "get_json_from_pdf", params);

/** Get the equipments from a site */
export const getEquipmentsAnnotations: GetEquipmentsAnnotations = context => axios.post(APIS.PLAN_API + "get_equipments_annotations", context);

/** Get the existing links */
export const getExistingLinks: GetExistingLinks = context => axios.post(APIS.PLAN_API + "get_existing_links", context);